const mappErrorCategoryToMessage = (category, insuranceType) => {
  const errorMapping = {
    invalid: {
      header: "We weren't able to verify your information",
      body: 'Please double check your information and try again.',
    },
    cant_reach_carrier: {
      header: "We weren't able to verify your information",
      body: 'You can try again or present your card at the clinic.',
    },
    insurance_not_active: {
      header: 'This insurance card is no longer active',
      body: 'You can try again or present your card at the clinic.',
    },
    flags: {
      header: `This clinic doesn't accept ${insuranceType}`,
      body: 'You can continue and use another form of insurance at the clinic.',
    },
  };
  return errorMapping[category];
};

export { mappErrorCategoryToMessage };
